import { styled } from '@mui/material/styles';

export const CarouselSlide = styled('div', {
    name: 'Carousel',
    slot: 'slide',
    skipSx: false,
})({
    transform: 'translate3d(0, 0, 0)',
    flex: '0 0 var(--slide-size)',
    minWidth: 0,
    userSelect: 'none',
});
